export default {
  title: 'Make it a menu?',
  item_only: 'Only item',
  make_it_combo: 'Make it a menu',
  or: 'Or',
  buttons: {
    item_only: 'Get Item Only',
    make_it_combo: 'Menu Deal',
  },
};
